import React, { useState, useEffect } from "react";
import { Form, Button, Container, Table, Modal } from "react-bootstrap";
import axios from "axios";
const url = process.env.REACT_APP_URL;

const BlogAdmin = () => {
  const [blogs, setBlogs] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    author: "",
    date: "",
    content: "",
    image: null,
    seotitle: "",
     seodescription: "",
     seokeywords: "",
     seoHeaderH1: "",
     seolink: "",
     seocanonical: "",
     seofaqSchema: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Fetch all blogs on component mount
  useEffect(() => {
    fetchBlogs();
  }, []);

  // Fetch all blogs
  const fetchBlogs = async () => {
    try {
      const response = await axios.get(
        `${url}/api/blogs/getAll`
      );
      setBlogs(response.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle image upload
  const handleFileChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      image: e.target.files[0],
    }));
  };

  // Submit form (Create/Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", formData.title);
    data.append("author", formData.author);
    data.append("date", formData.date);
    data.append("content", formData.content);
      data.append("seotitle", formData.seotitle);
      data.append("seodescription", formData.seodescription);
      data.append("seokeywords", formData.seokeywords);
      data.append("seoHeaderH1", formData.seoHeaderH1);
      data.append("seolink", formData.seolink);
      data.append("seocanonical", formData.seocanonical);
      data.append("seofaqSchema", formData.seofaqSchema);   
    if (formData.image) data.append("image", formData.image);

    try {
      if (editingId) {
        await axios.put(
          `${url}/api/blogs/update/${editingId}`,
          data
        );
      } else {
        await axios.post(`${url}/api/blogs/post`, data);
      }
      fetchBlogs();
      clearForm();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    setShowModal(false);
  };

  // Clear form and reset state
  const clearForm = () => {
    setFormData({
      title: "",
      author: "",
      date: "",
      content: "",
      image: null,
      seotitle: "",
     seodescription: "",
     seokeywords: "",
     seoHeaderH1: "",
     seolink: "",
     seocanonical: "",
     seofaqSchema: "",
    });
    setEditingId(null);
  };

  // Handle edit
  const handleEdit = (blog) => {
    setFormData({
      title: blog.title,
      author: blog.author,
      date: blog.date,
      content: blog.content,
      image: null,
       seotitle: blog.seotitle,
     seodescription: blog.seodescription,
     seokeywords: blog.seokeywords,
     seoHeaderH1: blog.seoHeaderH1,
     seolink: blog.seolink,
     seocanonical: blog.seocanonical,
     seofaqSchema: blog.seofaqSchema,
      
    });
    setEditingId(blog.id);
    setShowModal(true);
  };

  // Handle delete
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/blogs/delete/${id}`);
      fetchBlogs();
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  return (
    <Container className="mt-5">
      <h3>Blog Management</h3>
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className="mb-4"
      >
        Add Blog
      </Button>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Title</th>
            <th>Author</th>
            <th>Date</th>
            <th>Content</th>
            <th>Seo Tittle</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((blog) => (
            <tr key={blog.id}>
              <td>{blog.title}</td>
              <td>{blog.author}</td>
              <td>{blog.date}</td>
              <td>{blog.content.slice(0, 50)}...</td>
              <td>{blog.seotitle}</td>
              <td>
                <Button
                  variant="warning"
                  onClick={() => handleEdit(blog)}
                  className="me-2"
                >
                  Edit
                </Button>
                <Button variant="danger" onClick={() => handleDelete(blog.id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for Add/Edit Blog */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? "Edit Blog" : "Add Blog"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formAuthor" className="mt-3">
              <Form.Label>Author</Form.Label>
              <Form.Control
                type="text"
                name="author"
                value={formData.author}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formDate" className="mt-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formContent" className="mt-3">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                name="content"
                value={formData.content}
                onChange={handleChange}
                rows={3}
                required
              />
            </Form.Group>

            <Form.Group controlId="formImage" className="mt-3">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                onChange={handleFileChange}
                
              />
            </Form.Group>

       <Form.Group controlId="seotitle" className="mt-3">
                     <Form.Label>Meta Title</Form.Label>
                     <Form.Control
                       type="text"
                       name="seotitle"
                       value={formData.seotitle}
                       onChange={handleChange}
                     />
                   </Form.Group>
       
                   <Form.Group controlId="seodescription" className="mt-3">
                     <Form.Label>Meta Description</Form.Label>
                     <Form.Control
                       as="textarea"
                       name="seodescription"
                       value={formData.seodescription}
                       onChange={handleChange}
                       rows={2}
                     />
                   </Form.Group>
       
                   <Form.Group controlId="seokeywords" className="mt-3">
                     <Form.Label>Meta Keywords</Form.Label>
                     <Form.Control
                       as="textarea"
                       name="seokeywords"
                       value={formData.seokeywords}
                       onChange={handleChange}
                       rows={2}
                     />
                   </Form.Group>
       
                 <Form.Group controlId="seoHeaderH1" className="mt-3">
                     <Form.Label>Header Tag H1</Form.Label>
                     <Form.Control
                       as="textarea"
                       name="seoHeaderH1"
                       value={formData.seoHeaderH1}
                       onChange={handleChange}
                       rows={1}
                     />
                   </Form.Group>
                 <Form.Group controlId="seolink" className="mt-3">
                     <Form.Label>Page link</Form.Label>
                     <Form.Control
                       as="textarea"
                       name="seolink"
                       value={formData.seolink}
                       onChange={handleChange}
                       rows={1}
                     />
                   </Form.Group>
       
                <Form.Group controlId="seocanonical" className="mt-3">
                     <Form.Label>Canonical  Tag</Form.Label>
                     <Form.Control
                       as="textarea"
                       name="seocanonical"
                       value={formData.seocanonical}
                       onChange={handleChange}
                       rows={1}
                     />
                   </Form.Group>
       
               <Form.Group controlId="seofaqSchema" className="mt-3">
                     <Form.Label>Schema Mark-up JSON-LD</Form.Label>
                     <Form.Control
                       as="textarea"
                       name="seofaqSchema"
                       value={formData.seofaqSchema}
                       onChange={handleChange}
                       rows={5}
                     />
                   </Form.Group>

            <Button variant="primary" type="submit" className="mt-3">
              {editingId ? "Update" : "Submit"}
            </Button>
            <Button
              variant="secondary"
              onClick={clearForm}
              className="mt-3 ms-2"
            >
              Clear
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BlogAdmin;
